/*
 * Fifty Five – Proof-Band (Startseite). Gehoert zu sections/ff-proof-band.liquid.
 *
 * Georgs Entscheidung 2026-09-24: DIESE Fassung (echte Scroll-Spur, wischbar) bleibt. Drei-Satz-
 * Variante und CSS-Transform-Marquee wurden verworfen, Wischen ist wichtiger als ein perfekter
 * Uebergang an der Nahtstelle bei Karte 16.
 *
 * Drift auf einer ECHTEN Scroll-Spur: die Karten werden einmal dupliziert, dann waechst
 * scrollLeft pro Frame um speed/60 px; ist die erste Haelfte durch, springt die Spur um
 * genau eine Haelfte zurueck (nahtlos). Weil es eine normale Spur ist, kann man jederzeit
 * selbst wischen; dann pausiert der Drift und setzt nach 3 s Ruhe wieder ein.
 * Pause bei Hover, Fokus in der Spur, Beruehrung, ausserhalb des Viewports.
 * prefers-reduced-motion: kein Drift (Spur bleibt wischbar). Theme-Editor: shopify:section:load.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.ffpbReady === '1') return;
    root.dataset.ffpbReady = '1';
    var track = root.querySelector('[data-ffpb-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 3) return;

    /* Duplikat fuer die nahtlose Schleife; Kopien raus aus dem Zugriffsbaum. */
    items.forEach(function (it) {
      var c = it.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('ffpb__item--clone');
      track.appendChild(c);
    });
    if (reduced) return;

    var speed = parseFloat(getComputedStyle(root).getPropertyValue('--ffpb-speed')) || 28;
    var half = 0;
    var paused = false;
    var idleTimer = null;
    var visible = true;
    var last = 0;
    var userScrolling = false;
    /* scrollLeft rundet auf ganze Pixel; bei 28 px/s sind das 0,47 px pro Frame, die
       sonst jedes Mal verloren gingen. Deshalb eigener Gleitkomma-Stand. */
    var pos = 0;

    function measure() {
      /* Satzbreite exakt aus dem Layout (offsetLeft der ersten Kopie), kein gap-Parsing:
         Safari liefert fuer gap "normal". */
      var firstClone = track.children[items.length];
      half = firstClone ? firstClone.offsetLeft - items[0].offsetLeft : 0;
    }

    function step(ts) {
      if (!last) last = ts;
      var dt = Math.min(48, ts - last);
      last = ts;
      if (!paused && visible && !userScrolling && half > 0) {
        if (Math.abs(track.scrollLeft - pos) > 2) pos = track.scrollLeft;
        pos += speed * dt / 1000;
        if (pos >= half) pos -= half;
        track.scrollLeft = pos;
      }
      window.requestAnimationFrame(step);
    }

    function hold() { paused = true; clearTimeout(idleTimer); }
    function release() { clearTimeout(idleTimer); idleTimer = setTimeout(function () { paused = false; }, 3000); }

    root.addEventListener('pointerenter', hold);
    root.addEventListener('pointerleave', release);
    root.addEventListener('focusin', hold);
    root.addEventListener('focusout', release);
    track.addEventListener('touchstart', function () { hold(); userScrolling = true; }, { passive: true });
    track.addEventListener('touchend', function () { userScrolling = false; release(); }, { passive: true });
    track.addEventListener('scroll', function () {
      /* eigenes Wischen: Schleife auch dort schliessen */
      if (half > 0 && track.scrollLeft >= half) track.scrollLeft -= half;
      if (half > 0 && track.scrollLeft < 0) track.scrollLeft += half;
      if (userScrolling || paused) pos = track.scrollLeft;
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.05 }).observe(root);
    }
    window.addEventListener('resize', measure);
    measure();
    window.requestAnimationFrame(step);
  }

  function scan(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ffpb]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
